import { AlertTriangle, CheckCircle2, Sparkles } from "lucide-react";
import { analyzeSms } from "@/lib/smsQuality";

/* Live SMS deliverability hint shown under a message composer. `text` should be the FULL rendered
   message that actually goes out (i.e. the invite-preview result), not just the editable template,
   so the segment count and warnings are accurate. `onClean` cleans the parent's editable template. */
export function MessageQualityHint({ text, onClean, testId = "sms-quality" }) {
  const a = analyzeSms(text);
  if (!a.count) return null;
  const longMsg = a.segments >= 6;
  const warn = a.isUnicode || longMsg;
  return (
    <div data-testid={testId} className="mt-2 text-[11px]">
      <span className={`inline-flex items-center gap-1 font-semibold ${warn ? "text-amber-700" : "text-emerald-700"}`}>
        {warn ? <AlertTriangle className="h-3.5 w-3.5" /> : <CheckCircle2 className="h-3.5 w-3.5" />}
        {a.count} chars &middot; {a.segments} SMS segment{a.segments === 1 ? "" : "s"}
        {a.isUnicode ? " \u00b7 special-character encoding" : " \u00b7 standard encoding"}
      </span>
      {a.isUnicode && (
        <div className="mt-1.5 flex items-start gap-2 rounded-lg bg-amber-50 border border-amber-200 px-3 py-2 text-amber-800">
          <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0" />
          <span className="flex-1">
            Contains special characters ({a.offenderLabels.slice(0, 4).join(", ")}{a.offenderLabels.length > 4 ? "\u2026" : ""}) that force a longer encoding &mdash; some carriers reject these (the "didn't reach" bounces).
            {a.emojiLeft && " Emoji also cut how much fits in each text."}
            {" "}We auto-clean punctuation when sending, but you can fix it here so the preview matches exactly.
          </span>
          {onClean && a.hasCleanable && (
            <button type="button" data-testid={`${testId}-clean`} onClick={() => onClean()}
              className="shrink-0 inline-flex items-center gap-1 font-bold underline hover:no-underline">
              <Sparkles className="h-3 w-3" /> Clean it up
            </button>
          )}
        </div>
      )}
      {!a.isUnicode && longMsg && (
        <div className="mt-1.5 text-amber-700">This is long ({a.segments} segments) &mdash; consider shortening so carriers don&apos;t trim it.</div>
      )}
    </div>
  );
}
